import { getApiBaseUrl } from 'hypo-shared-utils';

export default {
  name: 'data-source-mixin',
  methods: {
    async getFeeScheduleListFromApi() {
      const params = new URLSearchParams({
        userId: this.options.userId,
        isGuid: !this.settings.isExternalUser,
        isNewVersion: true,
      });
      const url = `${getApiBaseUrl(
        '/api/v1/newfeeschedule/getnewfeeschedule',
        this.options.environment
      )}?${params.toString()}`;
      return window.mwc.dataAccess
        .fetch({
          url,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(res => res.json());
    },
    async applyFeeSchedule(feeScheduleId) {
      const params = new URLSearchParams({
        userId: this.options.userId,
        isGuid: !this.settings.isExternalUser,
        feeScheduleId,
        isDefault: 1,
      });
      const url = `${getApiBaseUrl(
        '/api/v1/newfeeschedule/setuserdefaultfeeschedule',
        this.options.environment
      )}?${params.toString()}`;
      return window.mwc.dataAccess
        .fetch({
          url,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(res => res.json());
    },
    async createOrUpdateFeeSchedule(feeScheduleData) {
      const params = new URLSearchParams({
        userId: this.options.userId,
        isGuid: !this.settings.isExternalUser,
        isNewVersion: true,
      });
      const url = `${getApiBaseUrl(
        '/api/v1/newfeeschedule/addupdatenewfeeschedule',
        this.options.environment
      )}?${params.toString()}`;
      return window.mwc.dataAccess
        .fetch({
          url,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(feeScheduleData),
        })
        .then(res => res.json());
    },
    async deleteFeeSchedule(feeScheduleId) {
      const params = new URLSearchParams({
        feeScheduleId,
        userId: this.options.userId,
        isGuid: !this.settings.isExternalUser,
      });
      const url = `${getApiBaseUrl(
        `/api/v1/newfeeschedule/deletefeeschedule`,
        this.options.environment
      )}?${params.toString()}`;
      return window.mwc.dataAccess
        .fetch({
          url,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(res => res.json());
    },
    async getProgramsInfo() {
      const params = new URLSearchParams({
        userId: this.options.userId,
        returnType: 2,
      });
      const url = `${getApiBaseUrl(
        `/api/v1/newfeeschedule/getinvestobjandprogram`,
        this.options.environment
      )}?${params.toString()}`;
      return window.mwc.dataAccess
        .fetch({
          url,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(res => res.json());
    },
  },
};
